import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PageHeader } from "@/components/PageHeader";
import { ErrorPage } from "@/components/ErrorPage";
import { toError } from "@/lib/utils";

export const Route = createFileRoute("/fillout")({
  component: RouteComponent,
  errorComponent: ({ error }) => <ErrorPage message={toError(error).message} />
});

function RouteComponent() {
  return (
    <div>
      <PageHeader />
      <Outlet />
    </div>
  );
}
